module.exports = __webpack_public_path__ + "img/ring_y_l_null_1@3x.3ae79ab4.png";